<template>
  <div>
    <h6>画像テキスト翻訳＆リサーチ</h6>
    <div class="box">
      <div class="pic">
        <!-- <canvas id="canvas_1" :width="width" :height="height">
          当前浏览器不支持 canvas
        </canvas> -->
        <img :src="img" alt="" id="img" />

        <el-button
          type="primary"
          size="mini"
          @click="downPic"
          style="background: #b4272d; border-color: #b4272d"
        >
          商品リサーチ</el-button
        >
      </div>
      <div class="listText">
        <h6>画像テキスト翻訳</h6>
        <div class="item" v-for="(item, index) in TextDetections" :key="index">
          <p>{{ index + 1 }} {{ item.text }}</p>
          <p class="brText">{{ index + 1 }} {{ item.DetectedTextBr }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { imageCharacter } from "../../api/API/home";

export default {
  data() {
    return {
      img: "",
      TextDetections: [{}, {}, {}, {}, {}, {}],
      width: "", // 画布宽
      height: "", // 画布高
      multiple: 1, // 倍数
    };
  },
  components: {},
  mounted() {},
  created() {
    this.recognition();
    // this.img = this.$route.query.imageUrl;
  },
  methods: {
    // 图片提取文字并翻译
    recognition() {
      this.img = this.$route.query.imageUrl;

      console.log(window.location.origin);
      imageCharacter({ imageUrl: this.img }).then((res) => {
        this.TextDetections = res.data;
      });

      //   延迟处理
      this.$nextTick(() => {
        var img = document.querySelector("#img");
        // 图片和画布大小处理
        if (img.offsetWidth > 1500) {
          this.multiple = 3;
        } else if (img.offsetWidth > 1000) {
          this.multiple = 2;
        } else if (img.offsetWidth > 660) {
          this.multiple = 1.5;
        } else {
          this.multiple = 1;
        }
        this.width = img.offsetWidth / this.multiple;
        this.height = img.offsetHeight / this.multiple;
        img.style.width = this.width + "px";
        img.style.height = this.height + "px";
      });
    },

    downPic() {
      var requestForm = document.createElement("form");
      requestForm.style = "display:none;";
      requestForm.method = "post";
      requestForm.action =
        "https://www.rakumart.com/index.php?mod=inc&act=alibabaimgsearch";
      requestForm.target = "_blank";

      // 参数-用户名
      let username = document.createElement("input");
      username.type = "hidden";
      username.name = "picUrl";
      username.value = this.img;
      requestForm.appendChild(username);

      // 参数-密码
      let password = document.createElement("input");
      password.type = "hidden";
      password.name = "page";
      password.value = "1";
      requestForm.appendChild(password);

      // 添加form
      document.body.appendChild(requestForm);
      // 发送请求
      requestForm.submit();
      // 删除form
      document.body.removeChild(requestForm);
    },
  },
};
</script>
<style >
body {
  width: 1060px;
}
</style>
<style lang='scss' scoped>
h6 {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  line-height: 40px;
  margin-bottom: 10px;
}
.box {
  width: 1060px;
  //   overflow: hidden;
  display: flex;

  .pic {
    flex: 2;
    text-align: center;
    position: relative;
    height: 650px;
    // transform: scale(0.5);

    #canvas_1 {
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 99;
      //   width: 800px;
      //   height: 800px;
    }
    img {
      //
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
  .listText {
    flex: 1;
    height: 600px;

    overflow-y: auto;
    margin-left: 10px;
    h6 {
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .item {
      border-bottom: 1px solid #ccc;
      padding: 5px;
      cursor: pointer;
      p {
        margin-bottom: 10px;
      }
      .brText {
        background-color: #b4272d;
        color: #fff;
      }
    }
  }
}
</style>